export interface IPostMessageModel {
    method: string;
    args: any;
}

export class PostMessageModel implements IPostMessageModel {
    method: string;
    args: any;
    constructor(method: string, args: any) {
        this.method = method;
        this.args = args || {};
    }
}